import React, { useRef, useEffect } from 'react';
import { connect } from "react-redux";
import { Routes, Route, Outlet, useRoutes, useLocation } from 'react-router';

import AuthUserProvider from './login/AuthUserContext';

import PrivateRoute from './login/PrivateRoute';
import WelcomePage from './welcome/WelcomePage';
import LoginPage from './login/LoginPageContainer';
import SignupPage from './login/SignupPageContainer';

import * as LoginActions from './login/actions';

import './css/App.css';

const App = ({
  dispatch,
  isInitialLogin
}) => {
  const ref = useRef(null);
  let pathname = useLocation().pathname;

  useEffect(() => {
    dispatch(initializeLogin());
  }, []);

  const route = useRoutes([
    {
      path: '/welcome',
      element: <WelcomePage />
    },
    {
      path: '/login',
      element: <LoginPage />
    },
    {
      path: '/signup',
      element: <SignupPage />
    },
    {
      path: '*',
      element: <PrivateRoute />
    }
  ]);

  return (
    <AuthUserProvider>
      {route}
    </AuthUserProvider>
  );
}

const initializeLogin = () => {
  return {
    type: LoginActions.LOGIN_INITIALIZED
  }
}

const mapStateToProps = state => ({
  isInitialLogin: state.login.isInitialLogin
});

export default connect(mapStateToProps)(App);
